import { deserializeJsonResponse, getDefaultOptions } from "./utils/fetch";
import displayErrorMessage from "./common_components/display-api-errors";
import $ from "jquery";

const publicApiAccessTokenKey = "mdae-api-access-token";
const publicApiBaseUrlKey = "mdae-api-base-url";

const abilityApiAccessTokenKey = 'ability-api-access-token';
const abilityApiBaseUrlKey = 'ability-api-base-url';

export const mdaeApiOktaAccessTokenKey = 'mdae-api-okta-access-token';
const mdaeApiBaseUrlKey = 'mdae-api-new-base-url';

const callExternalThoughspotApi = async (url, requestParams) => {
  return $.ajax({
    url: url,
  });
}

const callMvcApi = async (callMvcApiParams) => {
  const response = await window.fetch(callMvcApiParams.url, callMvcApiParams);
  const deserializedResponse = deserializeJsonResponse(response);
  displayErrorMessage(response);
  return deserializedResponse;
};
const callMvcApiblob = async (callMvcApiParams) => {
  const response = await window.fetch(callMvcApiParams.url, {
    ...callMvcApiParams,
    headers: {
      ...callMvcApiParams.headers,
      'Content-Type': 'application/json',
    },
  });  
  if (!response.ok) {
    displayErrorMessage(response);    
  }
  //Instead of deserializing JSON, read it as a blob
  const blob = await response.blob();
  return blob; 
};

const isErrorInResponse = async (response, responseBody) => {
  return new Promise<boolean>(async (resolve) => {
    if (response && response.status === 401) {
      resolve(true);
    } else if (response && response.status === 500) {
      resolve(true);
    } else if (responseBody && responseBody.ErrorCount > 0) {
      // Toast(responseBody.Errors.length && responseBody.Errors[0].Message, 'error');
      resolve(true);
    } else if (responseBody && responseBody.errorCount > 0) {
      // Toast(responseBody.errors.length && responseBody.errors[0].message, 'error');
      resolve(true);
    }
    resolve(false);
  });
};

const isErrorInAbilityResponse = async (response, responseBody) => {
  return new Promise<boolean>(async (resolve) => {
    if (response && response.status === 401) {
      resolve(true);
    } else if (response && response.status === 500) {
      resolve(true);
    } else if (responseBody && responseBody.errors.length > 0) {
      resolve(true);
    }
    resolve(false);
  });
};
async function getPublicApiAccessToken() {
  return new Promise<object>(async function (resolve, reject) {
    if (sessionStorage.getItem(publicApiAccessTokenKey) != null) {
      resolve({ success: true });
    } else {
      const requestParams: object = {
        ...getDefaultOptions(),
        method: "GET",
      };

      const response = await window.fetch(
        "/Api/MdaePublicApiHelper/AccessToken",
        requestParams
      );
      const decodedReponse = await deserializeJsonResponse(response);
      if (await isErrorInResponse(response, decodedReponse)) {
        reject(response);
      } else {
        sessionStorage.setItem(
          publicApiAccessTokenKey,
          decodedReponse.tokenData.token
        );
        sessionStorage.setItem(
          publicApiBaseUrlKey,
          decodedReponse.mdaePublicApiBaseUrl
        );
        resolve({ success: true });
      }
    }
  });
}

const callMdaePublicApi = async (callApiParams) => {
  const callWebApi = function () {
    return new Promise<object>(async (resolve, reject) => {
      if (callApiParams.url) {
        callApiParams.type = callApiParams.type ? callApiParams.type : "GET";
        callApiParams.contentType = callApiParams.contentType
          ? callApiParams.contentType
          : "application/json";
        callApiParams.dataType = callApiParams.dataType
          ? callApiParams.dataType
          : "JSON";
        let authorization;
        let authorizationName;

        getPublicApiAccessToken().then(async function () {
          if (callApiParams.isRoutedApiCall) {
            authorization = sessionStorage.getItem(publicApiAccessTokenKey);
            authorizationName = "Mdae-Authorization";
          } else {
            authorization =
              "Bearer " + sessionStorage.getItem(publicApiAccessTokenKey);
            authorizationName = "Authorization";
          }
          const requestUrl = callApiParams.isRoutedApiCall
            ? callApiParams.url
            : sessionStorage.getItem(publicApiBaseUrlKey) + callApiParams.url;
          // FormData bodies must NOT get an explicit Content-Type key at all (not
          // even `undefined`) — the fetch Headers constructor stringifies missing
          // values into the literal header "Content-Type: undefined" rather than
          // omitting it, which stops the browser from generating the multipart
          // boundary itself and breaks server-side form parsing.
          const isFormData = callApiParams.body instanceof FormData;
          const headers: Record<string, any> = {
            [authorizationName]: authorization,
            SessionContext: window.sessionStorage.getItem("SessionContext"),
            credentials: "same-origin",
          };
          if (callApiParams.type.toLowerCase() !== "get" && !isFormData) {
            headers["Content-Type"] = callApiParams.contentType;
          }
          const response = await window.fetch(requestUrl, {
            headers,
            body: callApiParams.body,
            method: callApiParams.type,
          });
          const decodedReponse = await deserializeJsonResponse(response);
          if (await isErrorInResponse(response, decodedReponse)) {
            reject(response);
          } else {
            resolve(decodedReponse);
          }
        });
      }
    });
  };

  return new Promise(function (resolve, reject) {
    callWebApi()
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        if (error.status === 401) {
          sessionStorage.removeItem(publicApiAccessTokenKey);
          callWebApi()
            .then(function (secondResponse) {
              resolve(secondResponse);
            })
            .catch(function (secondError) {
              reject(secondError);
            });
        } else {
          reject(error);
        }
      });
  });
};


async function getMdaeApiBaseUrl() {
    return new Promise<object>(async function (resolve, reject) {
        if (sessionStorage.getItem(mdaeApiBaseUrlKey) != null) {
            resolve({ success: true });
        } else {
            const requestParams: object = {
                ...getDefaultOptions(),
                method: "GET",
            };

            const response = await window.fetch(
                "/Api/MdaePublicApiHelper/enterpriseapibaseurl",
                requestParams
            );
            const decodedReponse = await deserializeJsonResponse(response);
            if (await isErrorInResponse(response, decodedReponse)) {
                reject(response);
            } else {
                sessionStorage.setItem(
                    mdaeApiBaseUrlKey,
                    decodedReponse.mdaeApiBaseUrl
                );
                resolve({ success: true });
            }
        }
    });
}

const callMdaeApi = async (callApiParams) => {
    const callApi = function () {
        return new Promise<object>(async (resolve, reject) => {
            if (callApiParams.url) {
                callApiParams.type = callApiParams.type ? callApiParams.type : "GET";
                callApiParams.contentType = callApiParams.contentType
                    ? callApiParams.contentType
                    : "application/json";
                callApiParams.dataType = callApiParams.dataType
                    ? callApiParams.dataType
                    : "JSON";
                let authorization;
                let authorizationName;

                getMdaeApiBaseUrl().then(async function() {
                  let mdaeApiOktaToken = sessionStorage.getItem(
                    mdaeApiOktaAccessTokenKey,
                  );
                  if (!mdaeApiOktaToken) {
                    try {
                      const data = await new Promise<string>(
                        (resolve, reject) => {
                          $.ajax({
                            url: "/api/utility/getaccesstoken",
                            type: "GET",
                            success: function(data) {
                              resolve(data);
                            },
                            error: function(error) {
                              reject(error);
                            },
                          });
                        },
                      );
                      (window as any).token = data;
                      sessionStorage.setItem(mdaeApiOktaAccessTokenKey, data);
                      mdaeApiOktaToken = data;
                    } catch (error) {
                      reject(error);
                      return;
                    }
                  }

                  authorization = "Bearer " + mdaeApiOktaToken;
                  authorizationName = "Authorization";

                  const requestUrl =
                    sessionStorage.getItem(mdaeApiBaseUrlKey) +
                    callApiParams.url;
                  const response = await window.fetch(requestUrl, {
                    headers: {
                      "Content-Type": callApiParams.contentType,
                      [authorizationName]: authorization,
                      //SessionContext: window.sessionStorage.getItem("SessionContext"),
                      //credentials: "same-origin",
                    },
                    body: callApiParams.body,
                    method: callApiParams.type,
                  });
                  const decodedReponse = await deserializeJsonResponse(
                    response,
                  );
                  if (await isErrorInResponse(response, decodedReponse)) {
                    reject(response);
                  } else {
                    resolve(decodedReponse);
                  }
                });
            }
        });
    };

    const callRefreshTokenEndpoint = function () {
        return new Promise<void>(function (resolve, reject) {

            $.ajax({
                url: '/account/refreshoktatoken',
                type: 'GET',
                success: function (data) {
                    if (!data || !data.accessToken) {
                        reject('unable to refresh okta token');
                    }
                    (window as any).token = data.accessToken;
                    sessionStorage.setItem(mdaeApiOktaAccessTokenKey, data.accessToken);
                    resolve();
                },
                error: function () {
                    reject('unable to refresh okta token');
                }
            });
        });
    } 

    return new Promise(function (resolve, reject) {
        callApi()
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                if (error.status === 401) {
                    // The Access token might be expired,
                    // 1. remove it from session
                    // 2. Try again, But this time call the refresh token endpoint which will get a new token and sets in session
                    // 3. call the requested API endpoint again

                    sessionStorage.removeItem(mdaeApiOktaAccessTokenKey);

                    callRefreshTokenEndpoint()
                        .then(function () {

                            callApi()
                                .then(function (secondResponse) {
                                    resolve(secondResponse);
                                })
                                .catch(function (secondError) {
                                    reject(secondError)
                                });

                        })
                        .catch(function (refreshError) {
                            reject(refreshError);
                        });

                } else {
                    reject(error);
                }
            });
    });
};

async function getAbilityApiAccessToken() {
  return new Promise<object>(async function (resolve, reject) {
    if (sessionStorage.getItem(abilityApiAccessTokenKey) != null && sessionStorage.getItem(abilityApiAccessTokenKey) != "undefined") {
      resolve({ success: true });
    } else {
      const requestParams: object = {
        ...getDefaultOptions(),
        method: "GET",
      };

      const response = await window.fetch(
        "/Api/AbilityApiHelper/AccessToken",
        requestParams
      );
      const decodedReponse = await deserializeJsonResponse(response);
      if (await isErrorInAbilityResponse(response, decodedReponse)) {
        reject(response);
      } else {
        sessionStorage.setItem(
          abilityApiAccessTokenKey,
          decodedReponse.tokenData.access_token
        );
        resolve({ success: true });
      }
    }
  });
}

const callAbilityApi = async (callApiParams) => {
  const callAbilityWebApi = function () {
    return new Promise<object>(async (resolve, reject) => {
      if (callApiParams.url) {
        callApiParams.type = callApiParams.type ? callApiParams.type : "GET";
        callApiParams.contentType = callApiParams.contentType
          ? callApiParams.contentType
          : "application/json";
        callApiParams.dataType = callApiParams.dataType
          ? callApiParams.dataType
          : "JSON";
        let authorization;
        let authorizationName;

        getAbilityApiAccessToken().then(async function () {
          authorization = sessionStorage.getItem(abilityApiAccessTokenKey);
          authorizationName = "Ability-Authorization";
          const requestUrl = callApiParams.url;
          const response = await window.fetch(requestUrl, {
            headers: {
              "Content-Type":
                callApiParams.type.toLowerCase() !== "get"
                  ? callApiParams.contentType
                  : undefined,
              [authorizationName]: authorization,
              SessionContext: window.sessionStorage.getItem("SessionContext"),
              credentials: "same-origin",
            },
            body: callApiParams.body,
            method: callApiParams.type,
          });
          const decodedReponse = await deserializeJsonResponse(response);
          if (await isErrorInAbilityResponse(response, decodedReponse)) {
            reject(response);
          } else {
            resolve(decodedReponse);
          }
        });
      }
    });
  };

  return new Promise(function (resolve, reject) {
    callAbilityWebApi()
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        if (error.status === 401) {
          sessionStorage.removeItem(abilityApiAccessTokenKey);
          callAbilityWebApi()
            .then(function (secondResponse) {
              resolve(secondResponse);
            })
            .catch(function (secondError) {
              reject(secondError);
            });
        } else {
          reject(error);
        }
      });
  });
};
export { callMvcApi, callMdaePublicApi, callAbilityApi, callExternalThoughspotApi, callMvcApiblob, callMdaeApi };
